import { render, staticRenderFns } from "./BaseTradingButton.vue?vue&type=template&id=b99577e8&scoped=true"
import script from "./BaseTradingButton.vue?vue&type=script&lang=js"
export * from "./BaseTradingButton.vue?vue&type=script&lang=js"
import style0 from "./BaseTradingButton.vue?vue&type=style&index=0&id=b99577e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99577e8",
  null
  
)

export default component.exports